import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const navbarContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  alignItems: "center",
  padding: { xs: "20px 0 20px 20px", sm: "20px 30px" },
  justifyContent: "space-between",
});
export const logoContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "center", sm: "space-between" },
  width: "100vw",
  "&:hover": {
    cursor: "pointer",
  },
});

export const navbarButton = ({ breakpoints }: Theme) => ({
  padding: "8px 30px",
  color: colors.main,
  whiteSpace: "nowrap",
});

export const navbarDownloadButton = ({ breakpoints }: Theme) => ({
  borderRadius: "50vh",
  backgroundColor: "#D8C6FF !important",
  color: "black !important",
  padding: "8px 24px",
  marginLeft: "30px",
});
